<template>
  <div style="padding: 30px 0">
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>候选人信息</b>
          </a-col>
        </a-row>
      </a-col>
      <a-col>
        <a-button type="link" icon="eye" size="large" @click="previewResume">查看附件简历</a-button>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="12" style="padding-left:20px">姓名：{{ source.resume.name }}</a-col>
      <a-col>公司：{{ source.resume.last_company }}</a-col>
      <a-col span="12" style="padding-left:20px">电话：{{ source.resume.mobile }}</a-col>
      <a-col>职能：{{ source.resume.title }}</a-col>
      <a-col
        span="12"
        style="padding-left:20px"
      >地点：{{`${source.resume.province_name}-${source.resume.city_name}`}}</a-col>
      <a-col>邮箱：{{ source.resume.email }}</a-col>
    </a-row>
    <!-- <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>顾问评价</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        {{
        source.report.adviser_remark
        }}
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>求职动机</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        {{
        source.report.motivation
        }}
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>推荐理由</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <template v-for="(item, index) in source.report.post_reason">
        <a-col span="24" :key="index" style="padding-left:20px">
          {{
          `${index + 1}、${item}`
          }}
        </a-col>
      </template>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>入职时间</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        {{
        source.report.expect_on_board_time_text
        }}
      </a-col>
    </a-row>
    <template v-if="source.report.expect_salary_basis > 0">
      <a-divider></a-divider>
      <a-row type="flex" justify="space-between" style="margin-bottom:15px">
        <a-col>
          <a-row type="flex" align="middle" :gutter="15">
            <a-col>
              <span style="height:25px;border-left:3px solid #35B5FE;"></span>
            </a-col>
            <a-col>
              <b>期望薪资</b>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start">
        <a-col span="24" style="padding-left:20px">
          {{
          `${
          source.report.expect_salary_type == "BEFORE" ? "税前" : "税后"
          }：${source.report.expect_salary_basis}元*${
          source.report.expect_salary_months
          } = ${source.report.expect_salary_basis *
          source.report.expect_salary_months}元`
          }}
          <span
            v-if="source.report.expect_income_extra"
          >（{{ source.report.expect_income_extra }}）</span>
        </a-col>
      </a-row>
    </template>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>目前薪资</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        {{
        `${
        source.report.current_salary_type == "BEFORE" ? "税前" : "税后"
        }：${source.report.current_salary_basis}元*${
        source.report.current_salary_months
        } = ${source.report.current_salary_basis *
        source.report.current_salary_months}元`
        }}
        <span
          v-if="source.report.current_income_extra"
        >（{{ source.report.current_income_extra }}）</span>
      </a-col>
    </a-row> -->
  </div>
</template>

<script>
export default {
  name: "Recommand",
  props: {
    source: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    previewResume() {
      this.$emit("view");
    }
  }
};
</script>
